<template>
	<div><span class="biaoti">留言管理</span>
		<el-tabs type="border-card">
			<el-tab-pane label="会员留言">
				<el-collapse>
					<el-collapse-item title="筛选">
						<el-form ref="form" :model="so" label-width="160px" style="margin-left: 80px;">
							<el-form-item label="ID">
								<el-input v-model="so.guanjianci" placeholder=""></el-input>
							</el-form-item>
							<el-form-item label="名称/手机/昵称/账号">
								<el-input v-model="so.guanjianci" placeholder=""></el-input>
							</el-form-item>
							<el-button size="medium" type="info" style="margin-left: 80px;" @click="CSH">搜索</el-button>
						</el-form>
					</el-collapse-item>
				</el-collapse>
				<el-table :data="lie">
					<el-table-column prop="id" label="ID" width="80">
						<template slot-scope="shu">
							<div>{{shu.row.id}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="ming" label="会员" width="180">
						<template slot-scope="shu">
							<image :src="shu.row.touxiang"></image>
							<div>{{shu.row.ming}}</div>
						</template>
					</el-table-column>
					<el-table-column label="留言内容" width="250">
						<template slot-scope="shu">
							<div>{{shu.row.neirong}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="dianhua" label="留言图片" width="150">
						<template slot-scope="shu">
							<image :src="shu.row.ltu"></image>
						</template>
					</el-table-column>
					<el-table-column prop="shijian" label="姓名/手机" width="240">
						<template slot-scope="shu">
							<div>{{shu.row.xinming}}/{{shu.row.dianhua}}</div>
						</template></el-table-column>
					<el-table-column prop="zhuangtai" label="提交时间">
						<template slot-scope="shu">
							<div>{{shu.row.shijian}}</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				shu: {},
				lie: [],
				tabs: "lie",
				so: {
					ye: 1,
					jitiao: 20
				},
				zongshu: 0
			};
		},
		created() {
			that = this;
			this.CSH();
		},
		methods: {
			CSH() {
				this.$post("m=zw_pige&k=liuyan", that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
		}
	};
</script>
<style scope>
	.annui {
		display: flex;
		justify-content: flex-start;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.hexiaoyuan {
		border: 1px dashed #dcdfe6;
		margin: 0 auto;
		width: 60%;
		display: flex;
		justify-content: space-between;
	}

	.shanghu {
		padding: 10px 40px;
	}

	.el-drawer__open .el-drawer.rtl {
		padding: 10px 30px;
	}
</style>
